module.exports = __webpack_public_path__ + "static/media/credit5.c8023e30.png";